export const features = [
  {
    id: "economia",
    icon: "ri-money-dollar-circle-line",
    title: "Economia Garantida",
    titleEn: "Economia Garantida",
    description: "Compare preços automaticamente e economize até 40% em cada compra internacional usando o Hoobuy Spreadsheet.",
    tag: "Até 40% off"
  },
  {
    id: "seguranca",
    icon: "ri-shield-check-line",
    title: "Segurança Total",
    titleEn: "Segurança Total",
    description: "Todos os links são verificados manualmente para evitar scams, produtos falsificados e links maliciosos.",
    tag: "100% Verificado"
  },
  {
    id: "velocidade",
    icon: "ri-flashlight-line",
    title: "Acesso Rápido",
    titleEn: "Acesso Rápido",
    description: "Encontre produtos em segundos com nossa planilha organizada por categorias, preços e tendências atualizadas.",
    tag: "Instantâneo"
  },
  {
    id: "organizacao",
    icon: "ri-file-list-3-line",
    title: "Tudo Organizado",
    titleEn: "Tudo Organizado",
    description: "14 categorias de produtos em uma única planilha. Chega de perder tempo procurando em dezenas de sites diferentes.",
    tag: "14 Categorias"
  }
];